<header class="d-flex align-items-center mt-3">
    <mat-icon (click)="getBackCase()">chevron_left</mat-icon>
    <h1>Administrador de archivos del caso <strong> #{{currentEntity?.code}}</strong></h1>
</header>
<main class="px-2 w-100 my-3">
    <div class="pt-3 custom-container">
        <div class="container-lg py-4 d-flex flex-column gap-5">
            <div class="row w-100 gy-4">
                <!-- Patient data -->
                <div class="col-12">
                    <mat-card class="card-general">
                        <mat-card-title>Datos del caso</mat-card-title>
                        <mat-card-content class="d-flex flex-column gap-4">
                            <div class="row">
                                <div class="col-12 col-sm-6 d-flex flex-wrap">
                                    <strong class="col-12 col-sm-3">ID Caso: </strong>
                                    <p>{{currentEntity?.Id ?? 'ID del caso'}}</p>
                                </div>
                                <div class="col-12 col-sm-6 d-flex flex-wrap">
                                    <strong class="col-12 col-sm-3">Paciente: </strong>
                                    <p>{{currentEntity?.patientFullName ?? 'Nombre del paciente'}}</p>
                                </div>
                                <div class="col-12 col-sm-6 d-flex flex-wrap">
                                    <strong class="col-12 col-sm-3">Fecha alta: </strong>
                                    <p>{{(currentEntity?.createdDate | dynamic: 'dateTime')}}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-6 d-flex flex-wrap">
                                    <strong class="col-12 col-sm-3">Edad: </strong>
                                    <p>{{(currentEntity?.patientBirthday | dynamic: 'age')}}</p>
                                </div>
                                <div class="col-12 col-sm-6 d-flex flex-wrap">
                                    <strong class="col-12 col-sm-3">Correo: </strong>
                                    <p>{{currentEntity?.patientEmail}}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-6 d-flex flex-wrap">
                                    <strong class="col-12 col-sm-3"># Etapa: </strong>
                                    <p># {{stageNumber}}</p>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </div>
        <div class="container-lg py-4 d-flex flex-column">
            <h4>Archivos del caso</h4>
            <div>
                <form [formGroup]="additionalFilesForm">
                    <div>
                        <mat-icon>description</mat-icon>
                        Archivos adicionales 
                    </div>
                    <div class="row">
                        <div class="col-12 col-md-4 my-4 mh-250px" *ngFor="let item of fileAdditionalArray; index as i">
                            <app-drag-and-drop [isReadOnly]="this.stageSelected?.statusId == Statuses.StageCancelled" [textWElipsis]="true" fileTitle="{{item.label}}" [parentForm]="additionalFilesForm" [nameControl]="item.name" isGenericFileType="true" [text]="this.stageSelected.statusId == 16?'Sin documento':'Inserta tu archivo aquí'" [accept]="application/octet-stream" (onSelectFile)="additionalFileSelected($event, item)" (onDeleteFile)="deleteAdditionalFileAction(item)" [fileSelected]="item.fileInfo">
                            </app-drag-and-drop>
                          </div>
                    </div>
                </form>
            </div>
            <hr class="divider">
            <h4>Archivos de la etapa {{stageNumber}}</h4>
            <div>
                <form [formGroup]="prescriptionForm">
                    <div>
                        <mat-icon>picture_as_pdf</mat-icon>
                        Prescripción
                    </div>
                    <div class="row">
                        <div class="col-12 col-md-4 my-4 mh-250px">
                            <app-drag-and-drop
                                [isReadOnly]="true"
                                [textWElipsis]="true"
                                [fileTitle]="this.stageSelected?.setup.prevPrescription ? 'Misma Prescripción del Setup anterior' : 'Prescripción del setup'"
                                [parentForm]="prescriptionForm" isGenericFileType="true"
                                [text]=" this.stageSelected?.statusId == 16?'Sin documento':'Inserta tu archivo aquí'"
                                [accept]="'application/octet-stream'" [nameControl]="filePrescription.name"
                                [fileSelected]="filePrescription.fileInfo" (onSelectFile)="prescriptionFileSelected($event)"
                                (onDeleteFile)="deletePrescriptionFile()">
                            </app-drag-and-drop>
                        </div>
                    </div>
                </form>
                <form [formGroup]="photographyForm">
                    <div class="row">
                        <div  class="col-12 col-md-4 my-4 mh-250px" *ngFor="let item of fileImageArray; index as i">
                            <div>
                                <mat-icon>photo</mat-icon>
                                Fotografía {{item.label}}
                            </div>
                            <app-drag-and-drop [isReadOnly]="this.stageSelected?.statusId == Statuses.StageCancelled" [textWElipsis]="true" fileTitle="Fotografía {{item.label}}" [parentForm]="photographyForm" [nameControl]="item.name" [text]="this.stageSelected.statusId == 16?'Sin documento':'Inserta tu archivo aquí'" [accept]="'image/*'" [isRequired]="item.isRequired" (onSelectFile)="fileSelected($event, item, 'imageComposite')" (onDeleteFile)="deleteFile(item, 'imageComposite')" [fileSelected]="item.fileInfo">
                            </app-drag-and-drop>
                        </div>
                    </div>
                </form>
                <form [formGroup]="compositeForm">
                    <div class="row">
                            <div class="col-12 col-md-4 my-4 mh-250px" *ngFor="let item of fileCompositeArray">
                                <div>
                                    <mat-icon>photo</mat-icon>
                                    {{item.name}} Dental
                                </div>
                                <app-drag-and-drop [isReadOnly]="this.stageSelected?.statusId == Statuses.StageCancelled" [textWElipsis]="true" fileTitle="{{item.name}} Dental" [parentForm]="compositeForm" [nameControl]="item.name" [text]="this.stageSelected.statusId == 16?'Sin documento':'Inserta tu archivo aquí'" [isRequired]="true" [accept]="'image/*'" (onSelectFile)="fileSelected($event, item, 'composite')"
                                                (onDeleteFile)="deleteFile(item, 'composite')" [fileSelected]="item.fileInfo">
                                </app-drag-and-drop>
                          </div>
                    </div>
                </form>
                <form [formGroup]="radiographyForm">
                    <div class="row">
                        <div class="col-12 col-md-4 my-4 mh-250px" *ngFor="let item of fileRadiographyArray">
                            <div>
                                <mat-icon>photo</mat-icon>
                                {{item.label}}
                            </div>
                            <app-drag-and-drop [isReadOnly]="this.stageSelected?.statusId == Statuses.StageCancelled" [textWElipsis]="true" fileTitle="{{item.label}}" [parentForm]="radiographyForm" [nameControl]="item.name" [text]="this.stageSelected.statusId == 16?'Sin documento':'Inserta tu archivo aquí'" [accept]="'image/*'" (onSelectFile)="fileSelected($event, item, 'radiography')"
                                            (onDeleteFile)="deleteFile(item, 'radiography')" [fileSelected]="item.fileInfo">
                            </app-drag-and-drop>
                        </div>
                    </div>
                </form>
                <form [formGroup]="stlForm">
                    <div class="row">
                        <div class="col-12 col-md-4 my-4 mh-250px" *ngFor="let item of fileSTLArray">
                            <div>
                                <mat-icon>description</mat-icon>
                                {{item.label}}
                            </div>
                            <ng-container *ngIf="item.name != 'BiteSTL'">
                                <app-drag-and-drop [stlOnly]="true" [isReadOnly]="this.stageSelected?.statusId == Statuses.StageCancelled" [textWElipsis]="true" fileTitle="{{item.label}}" [parentForm]="stlForm" [nameControl]="item.name" [text]="this.stageSelected.statusId == 16?'Sin documento':'Inserta tu archivo aquí'"[isRequired]="true" isGenericFileType="true" [accept]="application/octet-stream" (onSelectFile)="fileSelected($event, item, 'stl')"
                                                (onDeleteFile)="deleteFile(item, 'stl')" [fileSelected]="item.fileInfo">
                                </app-drag-and-drop>
                            </ng-container>
                            <ng-container *ngIf="item.name == 'BiteSTL'">
                                <app-drag-and-drop [stlZipOnly]="true" [isReadOnly]="this.stageSelected?.statusId == Statuses.StageCancelled" [textWElipsis]="true" fileTitle="{{item.label}}" [parentForm]="stlForm" [nameControl]="item.name" [text]="this.stageSelected.statusId == 16?'Sin documento':'Inserta tu archivo aquí'"[isRequired]="true" isGenericFileType="true" [accept]="application/octet-stream" (onSelectFile)="fileSelected($event, item, 'stl')"
                                                (onDeleteFile)="deleteFile(item, 'stl')" [fileSelected]="item.fileInfo">
                                </app-drag-and-drop>
                            </ng-container>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</main>